import { GetAgentPermissionsRequest, GetAgentPermissionsResult } from "@/services/emission/types";

export function useGetAgentPermissionsEmission() {
  const getAgentPermissions = async (req: GetAgentPermissionsRequest) => {
    const result = await fetch(`/api/emission/get-agent-permissions`, {
      body: JSON.stringify(req),
      method: "POST",
    });
    const { data } = await result.json();
    const resultJson = data as GetAgentPermissionsResult;
    return resultJson;
  };
  return getAgentPermissions;
}
